import BitcoinScreensaver from './components/BitcoinScreensaver'

function App() {
  return (
    <BitcoinScreensaver />
  )
}

export default App